import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData, Image, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class CongressContainerAgendaItemConverter extends CmsConverterService<CongressContainerAgendaItemData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_title_text?.value
    const altText = formData.st_alt_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      headline: formData.st_headline ?? defaultTextInput,
      image: CmsConverterService.mapImage(formData.st_image, lazyLoad, altText, title),
      tagline: formData.st_tagline ?? defaultTextInput,
      content: formData.st_content ?? defaultTextInput,
      hiddenContent: formData.st_hidden_content ?? defaultTextInput,
    }
  }
}

export const CONGRESS_CONTAINER_AGENDA_ITEM_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, CongressContainerAgendaItemData>>('CongressContainerAgendaItemConverter')

export interface CongressContainerAgendaItemData extends ConvertedComponentData {
  image: Image;
  headline: TextInput;
  tagline: TextInput;
  content: TextInput;
  hiddenContent: TextInput;
}
